import { useState } from 'react'

import { Hint } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import { track, trackingEvents } from 'modules/core/lib/Tracking'
import helpCenterUrl from 'modules/core/lib/helpCenterUrl'
import i18n from 'modules/core/lib/i18n'

import imgStep1 from './assets/step1.png'
import imgStep2 from './assets/step2.png'
import imgStep3 from './assets/step3.png'
import imgStep4 from './assets/step4.png'
import imgStep5 from './assets/step5.png'
import imgStep6 from './assets/step6.png'
import imgStep7 from './assets/step7.png'

export enum BreaksFrom {
  Rotating = 'rotating',
}

interface Props {
  from: BreaksFrom
  onClose: () => void
}

const BreaksHintModal = ({ from, onClose }: Props) => {
  const [currentStep, setCurrentStep] = useState<string>('0')

  const trackHowToSetUpBreaksFinish = (step: string) => {
    track(trackingEvents.shiftManagement.howToSetUpBreaksFinish, { from, step })
  }

  const onGoToSettings = () => {
    trackHowToSetUpBreaksFinish('7') // Last step
    onClose()
  }

  const onChange = (step: string) => {
    setCurrentStep(step)
  }

  const onCloseModal = () => {
    trackHowToSetUpBreaksFinish(currentStep)
    onClose()
  }

  const titleStep1 = i18n.t('shift_management.breaks_hint_modal.step_1_title')
  const descriptionStep1 = i18n.t('shift_management.breaks_hint_modal.step_1_description_1')

  const titleStep2 = i18n.t('shift_management.breaks_hint_modal.step_2_title')
  const descriptionStep2 = i18n.t('shift_management.breaks_hint_modal.step_2_description')

  const titleStep3 = i18n.t('shift_management.breaks_hint_modal.step_3_title')
  const descriptionStep3 = i18n.t('shift_management.breaks_hint_modal.step_3_description')

  const titleStep4 = i18n.t('shift_management.breaks_hint_modal.step_4_title')
  const descriptionStep4 = i18n.t('shift_management.breaks_hint_modal.step_4_description')

  const titleStep5 = i18n.t('shift_management.breaks_hint_modal.step_5_title')
  const descriptionStep5 = i18n.t('shift_management.breaks_hint_modal.step_5_description')

  const titleStep6 = i18n.t('shift_management.breaks_hint_modal.step_6_title')
  const descriptionStep6 = i18n.t('shift_management.breaks_hint_modal.step_6_description')

  const titleStep7 = i18n.t('shift_management.breaks_hint_modal.step_7_title')
  const descriptionStep7 = i18n.t('shift_management.breaks_hint_modal.step_7_description')

  const footerUrlLink = i18n.t('shift_management.breaks_hint_modal.step_7_link')

  return (
    <Hint.NewModal onClose={onCloseModal} onFinish={onClose} onChange={onChange}>
      <div id="1">
        <Hint.NewModal.ImageStep src={imgStep1} title={titleStep1} description={descriptionStep1} />
      </div>
      <div id="2">
        <Hint.NewModal.ImageStep src={imgStep2} title={titleStep2} description={descriptionStep2} />
      </div>
      <div id="3">
        <Hint.NewModal.ImageStep src={imgStep3} title={titleStep3} description={descriptionStep3} />
      </div>
      <div id="4">
        <Hint.NewModal.ImageStep src={imgStep4} title={titleStep4} description={descriptionStep4} />
      </div>
      <div id="5">
        <Hint.NewModal.ImageStep src={imgStep5} title={titleStep5} description={descriptionStep5} />
      </div>
      <div id="6">
        <Hint.NewModal.ImageStep src={imgStep6} title={titleStep6} description={descriptionStep6} />
      </div>
      <div id="7">
        <Hint.NewModal.ImageStep src={imgStep7} title={titleStep7} description={descriptionStep7}>
          <Hint.NewModal.ImageStep.ActionPanel
            actionLabel={i18n.t('common.close')}
            onActionClick={onGoToSettings}
            learnMoreLink={helpCenterUrl('time_settings_breaks')}
            learnMoreName={footerUrlLink}
          />
        </Hint.NewModal.ImageStep>
      </div>
    </Hint.NewModal>
  )
}

export default observer(BreaksHintModal)
